(function ($) {
	$.fn.menuItem = function () {
		let $el = $(this);
		const underline = $el.find('.menu-item__underline');
		const menuItemHeight = $el.outerHeight();

		const init = function () {
			// on load
			setMenuItemUnderlineHeight();

			// on resize
			$(window).on('resize', function () {
				setMenuItemUnderlineHeight();
			});
		};

		const setMenuItemUnderlineHeight = function () {
			// make underline height equal to 33% of stat value height in increments of 8px rounded up
			underline.css('height', Math.ceil((menuItemHeight * 0.33) / 8) * 8);
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).menuItem();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.menu-item').menuItem();
	});
})(jQuery);
